module.exports = __webpack_public_path__ + "img/ali.9ec25169.png";